import React from "react";
import BatchDeductionAction from "@icoach/batchPayment/component/BatchDeductionAction";
import BatchExcelDownloadAction from "@icoach/batchPayment/component/BatchExcelDownloadAction";
import BatchSmsSendAction from "@icoach/batchPayment/component/BatchSmsSendAction";
import { Icons } from "@curves/ui-base";

export const BATCH_DEBIT_HISTORY = "history";

export const ORDER_TYPES = {
	CURRENT: "current",
	EXEMPTED: "exempted",
	OVERDUE: "overdue"
};

export const PAYMENT_METHODS = {
	CASH: "cash",
	ACH: "ach",
	CREDIT: "credit"
};

export const preserveSearchParams = (searchParams = {}, params) => {
	const { type, date } = searchParams;
	return {
		type,
		date,
		...params
	};
};

export const MAIN_TAB = "main-tab";
export const SUB_TAB = "sub-tab";

export const BATCH_DEDUCTION = "batchDeduction";
export const BATCH_EXCEL_DOWNLOAD = "batchExcelDownload";
export const BATCH_SMS_SEND = "batchSmsSend";
export const getBatchActionConfigs = ({ searchParams, sourceData, refresh }) => ({
	[BATCH_DEDUCTION]: {
		label: "批次扣款",
		value: BATCH_DEDUCTION,
		startIcon: <Icons.DollarSign />,
		component: <BatchDeductionAction searchParams={searchParams} sourceData={sourceData} refresh={refresh} />
	},
	[BATCH_EXCEL_DOWNLOAD]: {
		label: "批次匯出",
		value: BATCH_EXCEL_DOWNLOAD,
		startIcon: <Icons.Download />,
		component: <BatchExcelDownloadAction searchParams={searchParams} sourceData={sourceData} refresh={refresh} />
	},
	[BATCH_SMS_SEND]: {
		label: "批次簡訊",
		value: BATCH_SMS_SEND,
		startIcon: <Icons.PaperPlane />,
		component: <BatchSmsSendAction searchParams={searchParams} sourceData={sourceData} refresh={refresh} />
	}
});


export const BATCH_PAYMENT_TYPE = {
	MEMBERSHIP: 1, // 會籍月費
	RENT_CABINET: 2, // 租櫃
	CYCLE_PURCHASE: 3, // 循環訂單
	SMART_FITNESS_BAND: 4 //智能系統
};

export const TAB_IDLE_STATE = "idleState";
export const TAB_SUCCESS_STATE = "successState";
export const TAB_FAILURE_STATE = "failureState";

export const BILLING_TARGET_FOR_CREDIT_CARD = 1;
export const BILLING_TARGET_FOR_ACH = 51;





